import { render, staticRenderFns } from "./MealConfirm.vue?vue&type=template&id=2994daab&scoped=true&"
import script from "./MealConfirm.vue?vue&type=script&lang=js&"
export * from "./MealConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MealConfirm.vue?vue&type=style&index=0&id=2994daab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994daab",
  null
  
)

export default component.exports